module.exports = __webpack_public_path__ + "static/img/ic_vip.9f4728e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_vip.png
// module id = dHYa
// module chunks = 1